import React,{Component} from 'react';
import firebase from '../../config'
import {Box,Button} from '@material-ui/core'
import {Switch,Link,Route} from 'react-router-dom'
import Add from './Add'
import Update from './Update'
import { Popconfirm} from 'antd';


export default class Categories extends Component{
    constructor(props){
        super(props)
        this.state={
            data:{
                "habits" :[],
                "health_risk" :[]
            }
        }
    }
    componentDidMount(){
        const getSubCollections = firebase
      .functions()
      .httpsCallable('getSubCollections');
    
      var arr = {}
      getSubCollections({ docPath: 'tests/habits' })
      .then(async (result) => {
        var collections = result.data.collections;
        console.log(collections)
        arr["habits"] = collections
        getSubCollections({ docPath: 'tests/health_risk' })
        .then(async (result) => {
          var collections = result.data.collections;
          console.log(collections)
          arr["health_risk"] = collections
          console.log(arr)
          this.setState({
              data : arr
          })
        })
        
      })
    }
    display = (props) =>{
        console.log(props)
        return(
            <Box m={3} display="flex" justifyContent="space-between">
                <Box>{props.name}</Box>
                <Box>
                    <Box display="flex" justifyContent="space-between" >
                        <Button m={2} variant="outlined" color="secondary" ><Link className="link-class" to={`${this.props.match.path}update/${props.type}/${props.name}`}>Update</Link></Button>
                        <Popconfirm
                                    title="Are you sure delete this task?"
                                    onConfirm={()=>this.confirm(props.type,props.name)}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                     <Button >Delete</Button>
                                </Popconfirm>

                    </Box>
                </Box>
            </Box>
        )

    }
    confirm =(type,name) =>{
        var ref =  firebase.firestore().collection('tests').doc(type).collection(name)
        ref.get().then(data =>{
            data.forEach(e =>{
                ref.doc(e.id).delete();
            })
        })

    }
    render(){
        console.log(this.state)
        if(this.props.location.pathname === "/categories"){
            return(
                <div>
                    <Box display="flex" flexDirection="row" justifyContent="space-between">
                        <Box b={1} m={8} w={50} flexDirection="column">
                        <Box fontSize="1.2em" textAlign="center">Habits</Box>

                            {
                                this.state.data["habits"].map(e=>{
                                    return <this.display name={e} type={"habits"} />
                                })
                            }
                        <Box><Button variant="contained" color="primary"><Link className="link-class" to={`${this.props.match.path}add/habits`}>Add habits</Link></Button> </Box>
                        </Box>
                        <Box b={1} m={8} w={50}>
                        <Box fontSize="1.2em" textAlign="center">health risk</Box>

                             {
                                this.state.data["health_risk"].map(e=>{
                                    return <this.display name={e} type={"health_risk"} />
                                })
                            }
                        <Box><Button variant="contained" color="primary"><Link className="link-class" to={`${this.props.match.path}add/heath_risk`}>Add Health risk</Link></Button> </Box>

                        </Box>

                    </Box>

                <Switch>
                    <Route  path={`${this.props.match.path}add/:type`}  component={Add}/>
                    <Route  path={`${this.props.match.path}update/:type/:category`}component={Update} />

                </Switch>
                </div>
            )

        }

        else return(
            <div>
                <Switch>
                    <Route  path={`${this.props.match.path}add/:type`}  component={Add}/>
                    <Route  path={`${this.props.match.path}update/:type/:category`} component={Update}  />
                </Switch>
                
            </div>
        )
    }
}